var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#FFAB82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.005 240.5C-62.9947 305 727.003 524.5 47.5033 637.5C-332.5 714.5 -293.495 639.35 -293.495 464C-293.495 288.65 128.546 -242.5 220.501 -242.5C312.457 -242.5 709.5 157.5 372.005 240.5Z",
    fill: "#2BA9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.5 590.5C1019.5 618.5 1032.38 664.745 964 668.5C895.619 672.255 754.191 680.334 740.905 639C730.307 606.032 719.22 578.268 787.601 574.513C855.982 570.758 998 565 1014.5 590.5Z",
    fill: "#00E49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.67 652.123C1752.84 738.685 1957.99 1063.5 1869 1112C1780.01 1160.5 1430.59 914.308 1383.42 827.745C1336.24 741.183 1324.04 656.819 1413.03 608.322C1502.01 559.825 1658.49 565.56 1705.67 652.123Z",
    fill: "#F04876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.65 607C1885.65 739.548 1918.53 910.5 1783.5 910.5C1648.47 910.5 1396.65 739.548 1396.65 607C1396.65 474.452 1483.47 357.5 1618.5 357.5C1753.53 357.5 1885.65 474.452 1885.65 607Z",
    fill: "#F3E73F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 449.5,
    width: 36,
    height: 229,
    rx: 18,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.5,
    y: 227.5,
    width: 332,
    height: 271,
    rx: 18,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730.5,
    y: 571.5,
    width: 274,
    height: 83,
    rx: 7.5,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.5,
    y: 255.5,
    width: 172,
    height: 70,
    rx: 7.5,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.5,
    y: 250.5,
    width: 78,
    height: 79,
    rx: 7.5,
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 250.5H655C659.142 250.5 662.5 253.858 662.5 258V269.5H584.5V258C584.5 253.858 587.858 250.5 592 250.5Z",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 659,
    r: 19,
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 258,
    width: 8,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603,
    y: 258,
    width: 8,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777,
    y: 288,
    width: 88,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 317,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 346,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 375,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 375,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162,
    y: 429,
    width: 51,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162,
    y: 452,
    width: 51,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 404,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 404,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 433,
    width: 87,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 462,
    width: 69,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 433,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 462,
    width: 111,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 432,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 443,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 455,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 466,
    width: 33,
    height: 5,
    rx: 2.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 309.828,
    width: 25.4112,
    height: 5,
    rx: 2.5,
    transform: "rotate(-63.9405 616 309.828)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633,
    y: 306.265,
    width: 13.3003,
    height: 5,
    rx: 2.5,
    transform: "rotate(-49.2997 633 306.265)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 300.083,
    width: 13.3003,
    height: 5,
    rx: 2.5,
    transform: "rotate(-49.2997 602 300.083)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.791,
    y: 297,
    width: 13.3003,
    height: 5,
    rx: 2.5,
    transform: "rotate(49.3 605.791 297)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.791,
    y: 289,
    width: 13.3003,
    height: 5,
    rx: 2.5,
    transform: "rotate(49.3 636.791 289)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.627 628.039L809.383 602.05C810.668 600.645 812.849 600.547 814.254 601.832V601.832C815.659 603.116 815.757 605.297 814.473 606.702L790.716 632.691L785.627 628.039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.5 632.5L764.52 608.425C763.125 607.132 763.035 604.957 764.318 603.553V603.553C765.607 602.143 767.795 602.045 769.205 603.334L795.185 627.082L790.5 632.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.999 409.5C620.999 408.119 622.119 407 623.499 407H682.499C683.88 407 684.999 408.119 684.999 409.5C684.999 410.881 683.88 412 682.499 412H623.499C622.119 412 620.999 410.881 620.999 409.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.499 412C622.119 412 620.999 410.881 620.999 409.5V350.5C620.999 349.119 622.119 348 623.499 348C624.88 348 625.999 349.119 625.999 350.5V409.5C625.999 410.881 624.88 412 623.499 412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.793 363.997C608.816 363.021 608.816 361.438 609.793 360.461L621.486 348.768C622.463 347.791 624.046 347.791 625.022 348.768C625.998 349.744 625.998 351.327 625.022 352.303L613.328 363.997C612.352 364.973 610.769 364.973 609.793 363.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.767 348.768C622.743 347.791 624.326 347.791 625.303 348.768L636.996 360.461C637.973 361.438 637.973 363.021 636.996 363.997C636.02 364.973 634.437 364.973 633.461 363.997L621.767 352.303C620.791 351.327 620.791 349.744 621.767 348.768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 409.5C1124 408.119 1122.88 407 1121.5 407H1062.5C1061.12 407 1060 408.119 1060 409.5C1060 410.881 1061.12 412 1062.5 412H1121.5C1122.88 412 1124 410.881 1124 409.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.5 412C1122.88 412 1124 410.881 1124 409.5V350.5C1124 349.119 1122.88 348 1121.5 348C1120.12 348 1119 349.119 1119 350.5V409.5C1119 410.881 1120.12 412 1121.5 412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.21 363.997C1136.18 363.021 1136.18 361.438 1135.21 360.461L1123.51 348.768C1122.54 347.791 1120.95 347.791 1119.98 348.768C1119 349.744 1119 351.327 1119.98 352.303L1131.67 363.997C1132.65 364.973 1134.23 364.973 1135.21 363.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.23 348.768C1122.26 347.791 1120.67 347.791 1119.7 348.768L1108 360.461C1107.03 361.438 1107.03 363.021 1108 363.997C1108.98 364.973 1110.56 364.973 1111.54 363.997L1123.23 352.303C1124.21 351.327 1124.21 349.744 1123.23 348.768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.5 457C681.119 457 680 455.881 680 454.5C680 453.119 681.119 452 682.5 452C683.881 452 685 453.119 685 454.5C685 455.881 683.881 457 682.5 457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 454.5C685 455.881 683.881 457 682.5 457H623.5C622.119 457 621 455.881 621 454.5C621 453.119 622.119 452 623.5 452H682.5C683.881 452 685 453.119 685 454.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.997 468.207C636.021 469.183 634.438 469.183 633.461 468.207L621.768 456.513C620.791 455.537 620.791 453.954 621.768 452.977C622.744 452.001 624.327 452.001 625.303 452.977L636.997 464.671C637.973 465.647 637.973 467.23 636.997 468.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.768 456.232C620.791 455.256 620.791 453.673 621.768 452.697L633.461 441.003C634.438 440.027 636.021 440.027 636.997 441.003C637.973 441.979 637.973 443.562 636.997 444.539L625.303 456.232C624.327 457.209 622.744 457.209 621.768 456.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.5 457.729C1063.88 457.729 1065 456.61 1065 455.229C1065 453.848 1063.88 452.729 1062.5 452.729C1061.12 452.729 1060 453.848 1060 455.229C1060 456.61 1061.12 457.729 1062.5 457.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 455.229C1060 456.61 1061.12 457.729 1062.5 457.729H1121.5C1122.88 457.729 1124 456.61 1124 455.229C1124 453.848 1122.88 452.729 1121.5 452.729H1062.5C1061.12 452.729 1060 453.848 1060 455.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108 468.936C1108.98 469.912 1110.56 469.912 1111.54 468.936L1123.23 457.242C1124.21 456.266 1124.21 454.683 1123.23 453.707C1122.26 452.73 1120.67 452.73 1119.7 453.707L1108 465.4C1107.03 466.377 1107.03 467.959 1108 468.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.23 456.961C1124.21 455.985 1124.21 454.402 1123.23 453.426L1111.54 441.732C1110.56 440.756 1108.98 440.756 1108 441.732C1107.03 442.709 1107.03 444.291 1108 445.268L1119.7 456.961C1120.67 457.938 1122.26 457.938 1123.23 456.961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529 422H594C596.761 422 599 424.239 599 427V477.603C599 478.927 597.927 480 596.603 480C591.683 480 588.604 485.322 591.057 489.587L591.591 490.515C593.426 493.705 589.035 496.776 586.667 493.959L577.417 482.956C575.841 481.082 573.518 480 571.069 480H529C526.239 480 524 477.761 524 475V427C524 424.239 526.239 422 529 422Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-1_48_1233",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.108 346.417C959.814 354.019 946.954 357.292 934.278 355.537C921.602 353.781 910.116 347.136 902.275 337.023C894.434 326.909 890.861 314.13 892.319 301.416C893.777 288.703 900.152 277.064 910.079 268.989L913.084 272.682C904.121 279.973 898.366 290.481 897.05 301.959C895.733 313.437 898.959 324.975 906.038 334.105C913.117 343.236 923.487 349.235 934.931 350.82C946.375 352.405 957.985 349.45 967.279 342.587L970.108 346.417Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M970.108 346.417C959.814 354.019 946.954 357.292 934.278 355.537C921.602 353.781 910.116 347.136 902.275 337.023C894.434 326.909 890.861 314.13 892.319 301.416C893.777 288.703 900.152 277.064 910.079 268.989L913.084 272.682C904.121 279.973 898.366 290.481 897.05 301.959C895.733 313.437 898.959 324.975 906.038 334.105C913.117 343.236 923.487 349.235 934.931 350.82C946.375 352.405 957.985 349.45 967.279 342.587L970.108 346.417Z",
    stroke: "black",
    strokeWidth: 8,
    mask: "url(#path-43-inside-1_48_1233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.5 282L967.5 309L958 323.5L921 328.5L947 307.5L947.5 305.5L947 304L946 302.5H944.5H943L916.5 323.5L929.5 288L945.5 282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.675 268.882C965.966 267.842 967.854 268.046 968.893 269.337L985.101 289.464C986.14 290.754 985.936 292.643 984.646 293.682L971.97 303.889L952 279.088L964.675 268.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1123.5,
    cy: 290.5,
    r: 19.5,
    fill: "#F04876"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1166.5,
    cy: 290.5,
    r: 19.5,
    fill: "#2BA9F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1209.5,
    cy: 290.5,
    r: 19.5,
    fill: "#F3E73F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.34 404.004C1224.36 404.182 1230 409.933 1230 417V457H1226V417C1226 412.029 1221.97 408 1217 408H1160C1155.03 408 1151 412.029 1151 417V498C1151 502.971 1155.03 507 1160 507H1207V511H1160C1152.93 511 1147.18 505.36 1147 498.336L1147 498V417C1147 409.82 1152.82 404 1160 404H1217L1217.34 404.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1207,
    cy: 509,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 457,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226 468C1230.42 468 1234.78 469.764 1239.08 472.853C1243.03 475.688 1246.83 479.575 1250.45 484.021C1242.39 494.277 1234.6 500 1226 500C1217.43 500 1208.67 493.331 1201.5 483.988C1209.53 473.303 1217.35 468 1226 468Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.5,
    cy: 483.5,
    r: 4.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.71 539.042C1084.09 545.418 1092.74 549 1101.75 549H1185C1201.57 549 1215 562.431 1215 579C1215 595.569 1201.57 609 1185 609H1085C1068.43 609 1055 595.569 1055 579V516.328L1077.71 539.042Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.63 589V586.654C1099.26 586.654 1099.77 586.473 1100.16 586.11C1100.55 585.747 1100.86 585.271 1101.11 584.682C1101.38 584.093 1101.64 583.458 1101.89 582.778L1108.52 564.588H1110.9L1118.15 583.118C1118.28 583.458 1118.46 583.979 1118.69 584.682C1118.92 585.362 1119.05 585.963 1119.1 586.484C1119.48 586.439 1119.85 586.416 1120.19 586.416C1120.55 586.393 1120.84 586.382 1121.07 586.382V589H1111.92V586.756C1112.56 586.756 1112.99 586.631 1113.22 586.382C1113.47 586.11 1113.58 585.747 1113.56 585.294C1113.53 584.841 1113.41 584.331 1113.18 583.764L1112.5 581.894L1105.12 582.03L1104.58 583.628C1104.47 583.923 1104.3 584.365 1104.07 584.954C1103.87 585.521 1103.67 585.997 1103.49 586.382C1103.85 586.337 1104.29 586.314 1104.78 586.314C1105.31 586.291 1105.68 586.28 1105.91 586.28V589H1098.63ZM1105.97 579.48H1111.65L1110.09 575.23C1109.79 574.414 1109.53 573.598 1109.31 572.782C1109.08 571.943 1108.91 571.207 1108.8 570.572H1108.76C1108.67 570.957 1108.54 571.535 1108.35 572.306C1108.17 573.077 1107.89 573.995 1107.5 575.06L1105.97 579.48ZM1132.05 589C1132.01 588.683 1131.97 588.422 1131.95 588.218C1131.95 587.991 1131.94 587.731 1131.92 587.436C1131.14 588.207 1130.33 588.751 1129.47 589.068C1128.61 589.385 1127.73 589.544 1126.85 589.544C1125.4 589.544 1124.27 589.113 1123.45 588.252C1122.63 587.391 1122.23 586.314 1122.23 585.022C1122.23 583.934 1122.5 583.005 1123.04 582.234C1123.61 581.463 1124.34 580.84 1125.25 580.364C1126.18 579.865 1127.2 579.491 1128.31 579.242C1129.44 578.97 1130.58 578.811 1131.71 578.766V576.998C1131.71 576.409 1131.63 575.876 1131.47 575.4C1131.34 574.924 1131.09 574.55 1130.73 574.278C1130.39 574.006 1129.9 573.881 1129.26 573.904C1128.83 573.927 1128.41 574.017 1128.01 574.176C1127.6 574.335 1127.25 574.561 1126.95 574.856C1127.13 575.06 1127.25 575.287 1127.29 575.536C1127.34 575.763 1127.36 575.967 1127.36 576.148C1127.36 576.601 1127.18 577.077 1126.82 577.576C1126.45 578.052 1125.87 578.279 1125.08 578.256C1124.4 578.233 1123.88 577.995 1123.52 577.542C1123.15 577.089 1122.97 576.556 1122.97 575.944C1122.97 575.037 1123.29 574.255 1123.93 573.598C1124.58 572.918 1125.46 572.397 1126.54 572.034C1127.63 571.649 1128.83 571.456 1130.15 571.456C1132.14 571.456 1133.68 571.977 1134.77 573.02C1135.88 574.04 1136.44 575.683 1136.44 577.95C1136.44 578.721 1136.44 579.378 1136.44 579.922C1136.44 580.466 1136.43 581.01 1136.4 581.554C1136.4 582.098 1136.4 582.755 1136.4 583.526C1136.4 583.843 1136.39 584.297 1136.37 584.886C1136.35 585.453 1136.31 585.997 1136.27 586.518C1136.65 586.473 1137.06 586.45 1137.49 586.45C1137.92 586.427 1138.25 586.416 1138.48 586.416V589H1132.05ZM1131.68 581.18C1131.04 581.248 1130.44 581.361 1129.88 581.52C1129.31 581.679 1128.81 581.894 1128.38 582.166C1127.97 582.438 1127.64 582.767 1127.39 583.152C1127.17 583.537 1127.05 583.968 1127.05 584.444C1127.08 585.079 1127.28 585.532 1127.67 585.804C1128.05 586.076 1128.49 586.212 1128.99 586.212C1129.51 586.212 1130 586.099 1130.45 585.872C1130.91 585.645 1131.31 585.351 1131.68 584.988C1131.68 584.761 1131.68 584.546 1131.68 584.342C1131.68 584.115 1131.68 583.889 1131.68 583.662C1131.68 583.254 1131.68 582.846 1131.68 582.438C1131.68 582.007 1131.68 581.588 1131.68 581.18ZM1140.57 589V586.756C1141.09 586.733 1141.52 586.665 1141.86 586.552C1142.22 586.439 1142.5 586.178 1142.68 585.77C1142.88 585.362 1142.98 584.705 1142.98 583.798V570.776C1142.98 570.164 1142.99 569.575 1143.02 569.008C1143.06 568.441 1143.1 568.011 1143.12 567.716C1142.76 567.739 1142.3 567.761 1141.76 567.784C1141.22 567.784 1140.82 567.795 1140.57 567.818V565.2C1142.13 565.177 1143.7 565.166 1145.26 565.166C1146.85 565.166 1148.42 565.155 1149.99 565.132C1152.71 565.109 1154.86 565.619 1156.45 566.662C1158.06 567.682 1158.8 569.235 1158.69 571.32C1158.65 571.977 1158.44 572.623 1158.08 573.258C1157.72 573.87 1157.17 574.425 1156.45 574.924C1155.74 575.423 1154.86 575.819 1153.8 576.114V576.148C1156.06 576.511 1157.73 577.27 1158.79 578.426C1159.86 579.559 1160.39 580.829 1160.39 582.234C1160.39 583.707 1160.03 584.954 1159.3 585.974C1158.6 586.971 1157.63 587.731 1156.38 588.252C1155.13 588.751 1153.72 589 1152.13 589H1140.57ZM1147.78 586.586C1148.19 586.586 1148.57 586.586 1148.93 586.586C1149.3 586.586 1149.66 586.586 1150.02 586.586C1150.38 586.563 1150.74 586.552 1151.08 586.552C1152.46 586.484 1153.47 586.042 1154.1 585.226C1154.74 584.41 1155.05 583.379 1155.05 582.132C1155.05 581.089 1154.84 580.273 1154.41 579.684C1153.98 579.072 1153.42 578.641 1152.74 578.392C1152.08 578.143 1151.39 578.018 1150.67 578.018C1150.1 578.018 1149.61 578.018 1149.21 578.018C1148.8 578.018 1148.37 578.029 1147.91 578.052V583.594C1147.91 584.206 1147.9 584.784 1147.88 585.328C1147.86 585.872 1147.82 586.291 1147.78 586.586ZM1147.91 575.638L1149.68 575.604C1150.63 575.581 1151.38 575.366 1151.93 574.958C1152.49 574.55 1152.89 574.006 1153.12 573.326C1153.36 572.623 1153.49 571.864 1153.49 571.048C1153.49 570.141 1153.31 569.439 1152.95 568.94C1152.58 568.419 1152.13 568.045 1151.59 567.818C1151.04 567.591 1150.47 567.489 1149.89 567.512C1149.52 567.512 1149.19 567.569 1148.9 567.682C1148.6 567.795 1148.37 568.056 1148.19 568.464C1148 568.849 1147.91 569.484 1147.91 570.368V575.638ZM1163.16 569.79C1163.16 569.382 1163.16 568.917 1163.16 568.396C1163.18 567.852 1163.21 567.331 1163.26 566.832C1162.9 566.855 1162.47 566.877 1161.97 566.9C1161.49 566.9 1161.13 566.911 1160.88 566.934V564.35C1161.94 564.35 1162.83 564.293 1163.53 564.18C1164.26 564.067 1164.82 563.931 1165.23 563.772C1165.66 563.613 1165.96 563.466 1166.12 563.33H1167.95V573.292C1168.72 572.612 1169.5 572.136 1170.3 571.864C1171.09 571.592 1171.84 571.456 1172.54 571.456C1173.9 571.456 1175.09 571.807 1176.11 572.51C1177.15 573.213 1177.96 574.21 1178.53 575.502C1179.11 576.794 1179.41 578.313 1179.41 580.058C1179.41 581.871 1179.07 583.503 1178.39 584.954C1177.73 586.382 1176.79 587.504 1175.57 588.32C1174.34 589.136 1172.87 589.544 1171.15 589.544C1170.54 589.544 1169.75 589.408 1168.8 589.136C1167.87 588.887 1167.01 588.343 1166.22 587.504L1165.2 589H1163.16V569.79ZM1167.95 583.9C1167.95 584.671 1168.08 585.283 1168.33 585.736C1168.57 586.189 1168.89 586.518 1169.28 586.722C1169.66 586.926 1170.05 587.039 1170.43 587.062C1171.45 587.085 1172.25 586.79 1172.81 586.178C1173.4 585.566 1173.81 584.761 1174.04 583.764C1174.29 582.744 1174.41 581.679 1174.41 580.568C1174.41 579.525 1174.29 578.539 1174.04 577.61C1173.79 576.681 1173.39 575.933 1172.85 575.366C1172.3 574.777 1171.59 574.493 1170.71 574.516C1170.14 574.539 1169.62 574.686 1169.14 574.958C1168.67 575.207 1168.27 575.547 1167.95 575.978V583.9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.430e1fa2f9115e96b393bcb24111d369.svg";
export { ForwardRef as ReactComponent };